import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Card, Typography, Typography as typography_antd } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import LeaveStyle from "../../Components/LeavesStyle";
import moment from "moment";
import ErrorIcon from "@mui/icons-material/Error";
import FilterListIcon from "@mui/icons-material/FilterList";
import "./attendance.css";
import { toast } from "react-toastify";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { addMonths, endOfMonth, format, startOfMonth } from "date-fns/esm";
import dayjs from "dayjs";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LoadingButton from "@mui/lab/LoadingButton";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { useDispatch, useSelector } from "react-redux";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice.js";
import { Navigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const { Title } = typography_antd;
const { default: env } = require("../../config/env.js");
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

const Attendance = (props) => {
  const startMonth = startOfMonth(new Date());
  const today_Date = moment(new Date()).format("YYYY-MM-DD");
  const [loading, setLoading] = useState(true);
  const [punchIn, setPunchIn] = useState(false);
  const [takeBreak, setTakeBreak] = useState(false);
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const [filterDetails, setFilterDetails] = useState([]);
  const [toDetails, setToDetails] = useState([]);
  const [openModal, setopenModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [employeeName, setEmployeeName] = useState("");
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [apiErr, setApiErr] = useState("");
  const [openFilterModal, setopenFilterModal] = useState(false);
  const [startDate, setstartDate] = useState(format(startMonth, "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(today_Date);
  const [count, setCount] = useState(0);
  const [openModalFinalPunchOut, setOpenModalFinalPunchOut] = useState(false);
  const [currentWorkingHrs, setCurrentWorkingHrs] = useState(0);
  const [errorText, setErrorText] = useState({
    daily_update: "",
    commit: "",
    reason: "",
    early_leave_reason: "",
  });
  const [updateTempMsg, setUpdateTempMsg] = useState("");
  const [earlyPunchOutMsg, setEarlyPunchOutMsg] = useState("");
  const [commit, setCommit] = useState("Yes");
  const [commitId, setCommitId] = useState("");
  const [reason, setReason] = useState("");
  const [disabledPunchIn, setDisabledPunchIn] = useState(false);
  const [disabledTakeBreak, setDisabledTakeBreak] = useState(false);
  const [disabledResuming, setDisabledResuming] = useState(false);
  const [disabledPunchOut, setDisabledPunchOut] = useState(false);
  const [disabledTempPunchOut, setDisabledTempPunchOut] = useState(false);
  let dispatch = useDispatch()
  let date = moment(new Date()).format("DD-MM-YYYY");
  let userId = props?.userData?.id;
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (employeeName) {
      fetchData();
    }
  }, [userId, date, apiErr, count, employeeName]);

  useEffect(() => {
    if (props?.userData?.name) {
      setEmployeeName(props?.userData?.name);
    }
  }, [props?.userData?.name]);

  useEffect(() => {
    let interval;

    if (isRunning) {
      interval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isRunning]);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return `${hours.toString().padStart(2, "0")} Hr  ${minutes
      .toString()
      .padStart(2, "0")} Min  ${seconds.toString().padStart(2, "0")} Sec`;
  };

  const fetchData = async () => {
    try {

      //Encrypt api endpoint
      const getAttendance = CryptoJS.SHA256("/getAttendance" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      // Encrypt data
      function encryptData(data) {
        const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
        return encodeURIComponent(encrypt)
      }

      const encryptedStartDate = encryptData(startDate);
      const encryptedEndDate = encryptData(endDate);

      const response = await fetch(
        `${env.backend_api_endpoint}/${getAttendance}?startDate=${encryptedStartDate}&endDate=${encryptedEndDate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login");
        }
        if (errorData?.status === 400) {
          setFilterDetails([]);
          setLoading(false);
        }
        throw new Error("Error fetching attendance details");
      }

      let data = [];

      data = await response.json();

      const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
      data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      setDisabledPunchIn(false);
      setDisabledTakeBreak(false);
      setDisabledResuming(false);
      setDisabledPunchOut(false);
      setDisabledTempPunchOut(false);

      if (filterModal == false) {
        const entriesForCurrentDate = [data[0]?.data[data[0]?.data.length - 1]];
        if (entriesForCurrentDate.length > 0) {
          // Find the latest entry based on punch in time
          const latestEntry = entriesForCurrentDate.reduce((prev, current) => {
            return moment(current.punch_in, "DD-MM-YYYY HH:mm:ss").isAfter(
              moment(prev.punch_in, "DD-MM-YYYY HH:mm:ss")
            )
              ? current
              : prev;
          });
          setToDetails(latestEntry);
          forTimmer(latestEntry, data);

          // Set takeBreak based on the latest entry's break status
          setTakeBreak(latestEntry.on_break === 1);
        } else {
          setToDetails([]);
          setTakeBreak(false);
        }
      }
      setAttendanceDetails(data);
      setFilterDetails(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attendance details:", error.message);
    }
  };

  const forTimmer = (latestEntry, data) => {
    // current Time
    const time = new Date();
    const sencodsDate = moment(time);
    const timeInSeconds = sencodsDate.format("HH:mm:ss");
    const convertedTime = moment.duration(timeInSeconds);
    let totalCurrentSeconds = convertInSecond(convertedTime);

    // Punch in Time
    let punchInDate = new Date(latestEntry?.punch_in);
    let punchInTimeTemp = convertHH_MM_SS(punchInDate);
    punchInTimeTemp = moment.duration(punchInTimeTemp);

    let totalPunchInSeconds = convertInSecond(punchInTimeTemp);

    const forBreak = data[0]?.data[data[0]?.data.length - 1]?.break_hours === null ? 0 : data[0]?.data[data[0]?.data.length - 1]?.break_hours;
    let totalTime = totalCurrentSeconds - totalPunchInSeconds - forBreak + data[0].totalWorkingHours;
    totalTime = Math.abs(totalTime);

    // For Break
    let tempArr = data[0]?.data[data[0]?.data.length - 1]?.break === null ? 0 : data[0]?.data[data[0]?.data.length - 1]?.break;
    tempArr = JSON.parse(tempArr);

    let userBreakTime = convertNormalHH_MM_SS(tempArr[tempArr.length - 1]?.break_in);
    userBreakTime = moment.duration(userBreakTime);

    const totalbreakSeconds = convertInSecond(userBreakTime);
    let t2 = totalCurrentSeconds - totalbreakSeconds;
    let dbBreakTime = totalTime - t2;

    const tempdbBreakTime = Math.abs(dbBreakTime);
    let valdbBreakTime = formatSecondInTime(tempdbBreakTime);
    const formattedTime = formatTime(totalTime);
    const breakformattedTime = formatTime(valdbBreakTime);

    if (
      data[0]?.data[data[0]?.data.length - 1]?.punch_out === null &&
      data[0]?.data[data[0]?.data.length - 1]?.on_break === false
    ) {
      setTime(totalTime);
      setIsRunning(true);
    } else if (data[0]?.data[data[0]?.data.length - 1]?.on_break === true) {
      setIsRunning(false);
      setTime(tempdbBreakTime);
    } else {
      setTime(data[0]?.date === date ? data[0]?.totalWorkingHours : 0);
      setIsRunning(false);
    }
  };

  const convertHH_MM_SS = (dateTime) => {
    const hours = String(dateTime.getHours()).padStart(2, "0");
    const minutes = String(dateTime.getMinutes()).padStart(2, "0");
    const seconds = String(dateTime.getSeconds()).padStart(2, "0");
    return hours + ":" + minutes + ":" + seconds;
  };

  const convertNormalHH_MM_SS = (dateTime) => {
    const time1 = dateTime?.split(" ")[1]?.split(":")[0];
    const time2 = dateTime?.split(" ")[1]?.split(":")[1];
    const time3 = dateTime?.split(" ")[1]?.split(":")[2];
    return time1 + ":" + time2 + ":" + time3;
  };

  const convertInSecond = (hms) => {
    let temVal = hms.hours() * 3600 + hms.minutes() * 60 + hms.seconds();
    return temVal;
  };

  const formatSecondInTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Formatting each part to have leading zeros if necessary
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  const handlePunchIn = async () => {
    setDisabledPunchIn(true);
    const message = "Punch In";
    if (employeeName !== "") {
      try {
        const punchIn = CryptoJS.SHA256("/punchIn" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const encryptedMessage = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();

        const response = await fetch(`${env.backend_api_endpoint}/${punchIn}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedMessage }),
        });
        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          throw new Error("Error punching in");
        }
        handleClearFilter();
      } catch (error) {
        // Handle error
        console.error("Error punching in:", error.message);
      }
    }
  };

  const handleCheckPunchOut = async () => {
    setDisabledTempPunchOut(true);
    if (employeeName !== "") {
      try {
        const checkPunchOut = CryptoJS.SHA256("/checkPunchOut" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const response = await fetch(
          `${env.backend_api_endpoint}/${checkPunchOut}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            // body: JSON.stringify({ userId }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            setopenModal(false);
            if (errorData?.msg != "User already on braek")
              toast.error(`${errorData?.msg}!`, {
                position: toast.POSITION.BOTTOM_RIGHT,
                toastId: "1",
              });
            if (errorData?.data?.on_break) {
              Modelhandler();
            }
          }

          throw new Error("Error punching out");
        }
        if (response.ok) {
          const errorData = await response.json();
          if (errorData?.status === 200) {
            let currentTimeHrs = Math.floor(time / 3600);
            setCurrentWorkingHrs(currentTimeHrs);
            setOpenModalFinalPunchOut(true);
          }
        }
      } catch (error) {
        console.error("Error punching out:", error.message);
      }
    }
  };

  const handleOnBreakPunchOut = async () => {
    setDisabledPunchOut(true);
    const message = "Punch Out";
    const codeCommit = commit === "Yes" ? true : false;
    const commitid = commitId === "" ? null : commitId.trim();
    const excuse = reason === "" ? null : reason.trim();
    const updateMsg = updateTempMsg.trim();
    const earlyLeaveReasonMsg = earlyPunchOutMsg.trim();
    if (employeeName !== "") {
      try {

        const data = {
          message,
          updateMsg,
          codeCommit,
          commitid,
          excuse,
          earlyLeaveReasonMsg,
        }

        const onbreakpunchOut = CryptoJS.SHA256("/onbreakpunchOut" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const encryptedResponse = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

        const response = await fetch(
          `${env.backend_api_endpoint}/${onbreakpunchOut}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            body: JSON.stringify({ encryptedData: encryptedResponse }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            setopenModal(false);
            setCurrentWorkingHrs(0);
            setOpenModalFinalPunchOut(false);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          throw new Error("Error punching out");
        }
        setopenModal(false);
        setCurrentWorkingHrs(0);
        setOpenModalFinalPunchOut(false);
        setUpdateTempMsg("");
        setCommit("Yes");
        setCommitId("");
        setReason("");
        setEarlyPunchOutMsg("");
        handleClearFilter();
      } catch (error) {
        console.error("Error punching out:", error.message);
      }
    }
  };

  const handleTakeBreak = async () => {
    setDisabledTakeBreak(true);
    const breakInTime = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
    // setBreakIn(breakInTime);
    const message = "Taking Break";
    if (employeeName !== "") {
      try {
        const takeBreak = CryptoJS.SHA256("/takeBreak" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const encryptedMessage = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();

        const response = await fetch(`${env.backend_api_endpoint}/${takeBreak}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedMessage }),
        });
        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          throw new Error("Error taking a break");
        }
        handleClearFilter();
      } catch (error) {
        console.error("Error taking a break:", error.message);
      }
    }
  };

  const handleResumeBreak = async () => {
    setDisabledResuming(true);
    const message = "Resuming Work";
    if (employeeName !== "") {
      try {
        const resumeBreak = CryptoJS.SHA256("/resumeBreak" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

        const encryptedMessage = CryptoJS.AES.encrypt(message, SECRET_KEY).toString();

        const response = await fetch(
          `${env.backend_api_endpoint}/${resumeBreak}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: token,
            },
            body: JSON.stringify({ encryptedMessage }),
          }
        );
        if (!response.ok) {
          const errorData = await response.json(); // Parse the response body as JSON
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
          if (errorData?.status === 400) {
            setApiErr(errorData?.msg);
            toast.error(`${errorData?.msg}!`, {
              position: toast.POSITION.BOTTOM_RIGHT,
              toastId: "1",
            });
          }
          throw new Error(errorData.error); // Throw the error message
        }
        handleClearFilter();
      } catch (error) {
        console.error("Error resuming:", error.message);
      }
    }
  };

  const Modelhandler = () => {
    setopenModal(true);
  };

  const closeModel = () => {
    setopenModal(false);
  };

  const FilterPopup = () => {
    setopenFilterModal(true);
    setFilterModal(true);
  };

  const handleDateChange = (e) => {
    if (e.$d !== null) {
      const newStartDate = moment(e.$d).format("YYYY-MM-DD");
      setstartDate(newStartDate);
    }
  };

  const handleToDateChange = (e) => {
    const newEndDate = moment(e.$d).format("YYYY-MM-DD");
    setEndDate(newEndDate);
  };

  const handleFilterYear = (key) => {
    if (key == 1) {
      setstartDate(format(startMonth, "yyyy-MM-dd"));
      setEndDate(today_Date);
    }
    if (key == 2) {
      setstartDate(
        format(startOfMonth(addMonths(new Date(), -1)), "yyyy-MM-dd")
      );
      setEndDate(format(endOfMonth(addMonths(new Date(), -1)), "yyyy-MM-dd"));
    }
    if (key == 3) {
      setstartDate(moment().startOf("year").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("year").format("YYYY-MM-DD"));
    }
    if (key == 4) {
      setstartDate(
        moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD")
      );
      setEndDate(
        moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD")
      );
    }
  };

  const filterdsumbit = () => {
    setLoading(true);
    fetchData();
    setopenFilterModal(false);
  };

  const handleClearFilter = () => {
    setstartDate(format(startMonth, "yyyy-MM-dd"));
    setEndDate(today_Date);
    setFilterModal(false);
    setCount(count + 1);
    setopenFilterModal(false);
  };

  const closeFilterModel = () => {
    setopenFilterModal(false);
    setFilterModal(false);
  };

  const handlePunchOutConfirm = () => {
    const commitOrReason = commit === "Yes" ? commitId : reason;

    if (
      updateTempMsg.trim() === "" ||
      commitOrReason.trim() === "" ||
      (earlyPunchOutMsg.trim() === "" && currentWorkingHrs < 8)
    ) {
      if (
        commit === "Yes" &&
        commitId.trim() === "" &&
        updateTempMsg.trim() === ""
      ) {
        setErrorText({
          ...errorText,
          daily_update: "Please Enter Your End of Day Report!",
          commit: "Please Enter Your Commit ID!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        commit === "No" &&
        reason.trim() === "" &&
        updateTempMsg.trim() === ""
      ) {
        setErrorText({
          ...errorText,
          daily_update: "Please Enter Your End of Day Report!",

          reason: "Please Enter Your  Code Commit Excuse!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        (updateTempMsg.trim() === "" &&
          commit === "Yes" &&
          commitId.trim() !== "") ||
        (commit === "No" && reason.trim() !== "")
      ) {
        setErrorText({
          ...errorText,
          daily_update: "Please Enter Your End of Day Report!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        commit === "Yes" &&
        commitId.trim() === "" &&
        updateTempMsg.trim() !== ""
      ) {
        setErrorText({
          ...errorText,
          commit: "Please Enter Your Commit ID!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        commit === "No" &&
        reason.trim() === "" &&
        updateTempMsg.trim() !== ""
      ) {
        setErrorText({
          ...errorText,
          reason: "Please Enter Your  Code Commit Excuse!",
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
      if (
        earlyPunchOutMsg.trim() == "" &&
        ((commit === "Yes" &&
          commitId.trim() !== "" &&
          updateTempMsg.trim() !== "") ||
          (commit === "No" &&
            reason.trim() !== "" &&
            updateTempMsg.trim() !== ""))
      ) {
        setErrorText({
          ...errorText,
          early_leave_reason:
            earlyPunchOutMsg.trim() == ""
              ? "Please Enter Your Reason for early Punch Out!"
              : "",
        });
      }
    } else {
      handleOnBreakPunchOut();
    }
  };

  return (
    <LeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{ height: "85vh" }}
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          <div className="AllEmployeeHeaderWrapper" style={{ padding: "0px" }}>
            <div className="attendance_AllEmployeeHeader">
              <div className="HeaderTitle ">
                <Title
                  level={2}
                  style={{
                    color: "#244DA0",
                    fontFamily: "ImportedMilliardBold",
                    marginBottom: "0px",
                  }}
                >
                  Attendance
                </Title>
                <div className="iconFilterDown" style={{ marginTop: "0px" }}>
                  <FilterListIcon onClick={FilterPopup} />
                </div>
              </div>

              <div className="btn-flex" style={{ alignItems: "center" }}>
                <h3 style={{ marginRight: "15px", color: "#244DA0" }}>
                  {formatTime(time)}
                </h3>
                <div className="cmn_box" style={{ marginRight: "20px" }}>
                  {toDetails?.length !== 0 &&
                    toDetails?.on_break == 0 &&
                    toDetails?.punch_out === null && (
                      <LoadingButton
                        id="assign_leave"
                        size="large"
                        onClick={handleTakeBreak}
                        loading={disabledTakeBreak}
                        variant="contained"
                        style={{
                          backgroundColor: "orange",
                          borderRadius: "6px",
                          color: "white",
                          fontWeight: "500",
                          borderColor: "#244DA0",
                          textTransform: "none",
                          height: "44px",
                          width: "130px",
                          fontFamily: "MilliardMedium"
                        }}
                      >
                        <span> {disabledTakeBreak ? "" : "Take Break"}</span>
                      </LoadingButton>
                    )}
                  {toDetails?.length !== 0 && toDetails?.on_break == 1 && (
                    <LoadingButton
                      id="assign_leave"
                      size="large"
                      onClick={handleResumeBreak}
                      loading={disabledResuming}
                      variant="contained"
                      style={{
                        backgroundColor: "#0fa297",
                        borderRadius: "6px",
                        color: "white",
                        fontWeight: "500",
                        borderColor: "#244DA0",
                        textTransform: "none",
                        height: "44px",
                        width: "130px",
                        fontFamily: "MilliardMedium"
                      }}
                    >
                      <span>{disabledResuming ? "" : "Resuming"}</span>
                    </LoadingButton>
                  )}
                </div>
                <div className="cmn_box">
                  {(toDetails.length == 0 || toDetails.punch_out !== null) && (
                    <LoadingButton
                      size="large"
                      onClick={handlePunchIn}
                      loading={disabledPunchIn}
                      variant="contained"
                      style={{
                        backgroundColor: "#244DA0",
                        borderRadius: "6px",
                        color: "white",
                        fontWeight: "500",
                        borderColor: "#244DA0",
                        textTransform: "none",
                        height: "44px",
                        width: "150px",
                        fontFamily: "MilliardMedium"
                      }}
                    >
                      <span style={{ display: "flex", alignItems: "center" }}>
                        {disabledPunchIn ? (
                          ""
                        ) : (
                          <>
                            <FingerprintIcon style={{ marginRight: "5px" }} />
                            Punch In
                          </>
                        )}
                      </span>
                    </LoadingButton>
                  )}

                  {toDetails?.length !== 0 && toDetails?.punch_out === null && (
                    <LoadingButton
                      size="large"
                      onClick={handleCheckPunchOut}
                      loading={disabledTempPunchOut}
                      variant="contained"
                      style={{
                        backgroundColor: "red ",
                        borderRadius: "6px",
                        color: "white",
                        fontWeight: "500",
                        borderColor: "#244DA0",
                        height: "44px",
                        width: "130px",
                        fontFamily: "MilliardMedium",
                        textTransform: "none",
                      }}
                    >
                      <span>{disabledTempPunchOut ? "" : "Punch Out"}</span>
                    </LoadingButton>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="All_employee_table attendance-box">
            {!loading ? (
              <>
                {" "}
                {filterDetails?.length > 0 ? (
                  filterDetails.map((tempval) => {
                    const date = new Date(tempval?.date);
                    let mdate = moment(date);
                    const day = mdate.format("dddd");
                    const onlyDate = mdate.format("DD");
                    const month = mdate.format("MMMM");

                    return (
                      <>
                        <Typography
                          variant="h1"
                          gutterBottom
                          className="temp-Date"
                        >
                          {day},{onlyDate} {month}{" "}
                          {tempval?.data[0].punch_in
                            ?.split(" ")[1]
                            .split(":")[0] >= 11 &&
                            tempval?.data[0].punch_in
                              ?.split(" ")[1]
                              .split(":")[1] > 0 && (
                              <span className="late_in_tag">Late</span>
                            )}
                        </Typography>
                        <TableContainer
                          component={Paper}
                          className="table-attendance"
                          sx={{
                            // maxHeight: "460px",
                            borderTopLeftRadius: 15,
                            borderTopRightRadius: 15,
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                          }}
                        >
                          <Table
                            sx={{
                              minWidth: 650,
                              '& th, & td': {
                                border: '1px solid #f0f0f0',
                              },
                            }}
                            aria-label="simple table"
                          >
                            <TableHead className="table_Header_color" sx={{ height: "40px" }}>
                              <TableRow
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                  backgroundColor: "#244DA0",
                                }}
                              >
                                <TableCell style={{ color: "white" }}>
                                  Date
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Punch In
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Punch Out
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Break Hours
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Working Hours{" "}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {tempval?.data?.map((row) => {
                                let punchOutDate = new Date(row?.punch_out);
                                let punchInDate = new Date(row?.punch_in);
                                const a = row?.punch_out
                                  ? String(punchOutDate.getHours()).padStart(2, "0") + ":" +
                                  String(punchOutDate.getMinutes()).padStart(2, "0") : "00:00";

                                const b = String(punchInDate.getHours()).padStart(2, "0") + ":" +
                                  String(punchInDate.getMinutes()).padStart(2, "0");

                                const time = moment(a, "HH:mm").format("hh:mm A");
                                const punchIntime = moment(b, "HH:mm").format("hh:mm A");

                                return (
                                  <>
                                    <TableRow
                                      key={row?.id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell>{row?.date}</TableCell>
                                      <TableCell>
                                        <div className="value_box">
                                          <AccessTimeIcon className="timer_icon" />
                                          <p>
                                            {/* {
                                              row?.punch_in
                                                ?.split(" ")[1]
                                                .split(":")[0]
                                            }
                                            :
                                            {
                                              row?.punch_in
                                                ?.split(" ")[1]
                                                .split(":")[1]
                                            } */}
                                            {punchIntime}
                                          </p>
                                        </div>
                                      </TableCell>
                                      <TableCell>
                                        <div className="value_box">
                                          <AccessTimeIcon className="timer_icon" />
                                          <p>
                                            {row?.punch_out ? time : "00:00"}
                                          </p>
                                        </div>
                                      </TableCell>
                                      <TableCell>
                                        <div className="value_box">
                                          <AccessTimeIcon className="timer_icon" />
                                          <p>
                                            {Math.floor(
                                              row?.break_hours / 3600
                                            )}{" "}
                                            Hr{" "}
                                            {Math.floor(
                                              (row?.break_hours % 3600) / 60
                                            )}{" "}
                                            Min{" "}
                                            {Math.floor(row?.break_hours % 60)}{" "}
                                            Sec{" "}
                                          </p>
                                        </div>
                                      </TableCell>
                                      <TableCell>
                                        <div className="value_box">
                                          <AccessTimeIcon className="timer_icon" />
                                          <p>
                                            {row?.working_hours == null
                                              ? "0 Hr 0 Min 0 Sec"
                                              : `${Math.floor(
                                                row?.working_hours / 3600
                                              )} Hr  ${Math.floor(
                                                (row?.working_hours % 3600) /
                                                60
                                              )} Min ${Math.floor(
                                                row?.working_hours % 60
                                              )} Sec`}
                                          </p>
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <div className="flex hours-div">
                          <div className="flex">
                            <Typography
                              variant="h1"
                              gutterBottom
                              className="hours-key"
                            >
                              Total Break Hours:
                            </Typography>

                            <span className="hours-value">
                              {`${Math.floor(
                                tempval?.totalBreakHours / 3600
                              )} Hr  ${Math.floor(
                                (tempval?.totalBreakHours % 3600) / 60
                              )} Min ${Math.floor(
                                tempval?.totalBreakHours % 60
                              )} Sec`}{" "}
                            </span>
                          </div>
                          <div className="flex">
                            <Typography
                              variant="h1"
                              gutterBottom
                              className="hours-key"
                            >
                              Total Working Hours:
                            </Typography>
                            <span className="hours-value">
                              {`${Math.floor(
                                tempval?.totalWorkingHours / 3600
                              )} Hr  ${Math.floor(
                                (tempval?.totalWorkingHours % 3600) / 60
                              )} Min ${Math.floor(
                                tempval?.totalWorkingHours % 60
                              )} Sec`}
                            </span>
                          </div>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <p style={{ textAlign: "center" }}>No records found.</p>
                  </div>
                )}
              </>
            ) : (
              <span class="loader"></span>
            )}
          </div>

          <Dialog open={openModal}>
            <DialogContent>
              <center>
                <ErrorIcon style={{ fontSize: "50px" }} />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                You are on Break
              </p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Are you sure want to Punch Out?
              </p>
            </DialogContent>
            <DialogActions
              style={{ justifyContent: "center", marginBottom: "10px" }}
            >
              <Button
                block
                size="large"
                key="submit"
                type="primary"
                onClick={closeModel}
                style={{
                  backgroundColor: "#E20E0E",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#E20E0E",
                  textTransform: "none",
                  width: "120px",
                }}
              >
                No
              </Button>
              <Button
                size="large"
                block
                key="back"
                id="btndelete"
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  color: "white",
                  textTransform: "none",
                  width: "120px",
                }}
                onClick={() => {
                  let currentTimeHrs = Math.floor(time / 3600);
                  setCurrentWorkingHrs(currentTimeHrs);
                  setOpenModalFinalPunchOut(true);
                  closeModel();
                }}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          {/* Filter Dialog */}
          <Dialog open={openFilterModal} className="filter_model">
            <DialogTitle
              id="Leave_title"
              className="d-flex"
              style={{ justifyContent: "space-between" }}
            >
              Filters
              <div>
                <Button
                  onClick={handleClearFilter}
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    borderColor: "#244DA0",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Clear All
                </Button>
              </div>
            </DialogTitle>
            <Divider />
            <DialogContent>
              <div className="filter_Dialog_attendance">
                <div style={{ display: "flex" }}>
                  <div className="mr_div">
                    <Typography className="label_text">
                      From Date <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={dayjs(startDate)}
                        onChange={(e) => handleDateChange(e)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <div>
                    <Typography className="label_text">
                      To Date <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        minDate={dayjs(startDate)}
                        value={dayjs(endDate)}
                        onChange={(e) => handleToDateChange(e)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="d_flex">
                  <span
                    className="bottom_range"
                    onClick={(key) => handleFilterYear(1)}
                  >
                    This Month
                  </span>
                  <span
                    className="bottom_range"
                    onClick={(key) => handleFilterYear(2)}
                  >
                    Last Month
                  </span>
                  <span
                    className="bottom_range"
                    onClick={(key) => handleFilterYear(3)}
                  >
                    This Year
                  </span>
                  <span
                    className="bottom_range"
                    onClick={(key) => handleFilterYear(4)}
                  >
                    Previous Year
                  </span>
                </div>
              </div>
            </DialogContent>
            <Divider />
            <DialogActions
              style={{ justifyContent: "space-around", margin: "0px" }}
            >
              <div className="button-container" onClick={closeFilterModel}>
                <Button
                  block
                  size="large"
                  className="btn_hover_effect"
                  style={{
                    borderRadius: "6px",
                    color: "red",
                    fontWeight: "500",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Close
                </Button>
              </div>
              <div className="button-container" onClick={filterdsumbit}>
                <Button
                  size="large"
                  block
                  key="back"
                  className="btn_hover_effect"
                  style={{
                    borderRadius: "6px",
                    color: "#244DA0",
                    fontWeight: "500",
                    padding: "5px 25px",
                    textTransform: "none",
                  }}
                >
                  Apply
                </Button>
              </div>
            </DialogActions>
          </Dialog>

          {/* Final PunchOut Dialog */}
          <Dialog open={openModalFinalPunchOut} fullWidth>
            <div className="final_punchout_dialog">
              <DialogContent>
                <div>
                  <Title
                    level={3}
                    style={{
                      color: "#244DA0",
                      fontFamily: "ImportedMilliardBold",
                    }}
                  >
                    Task Report
                  </Title>
                  {currentWorkingHrs < 8 ? (
                    <div>
                      <Typography className="label_text_final_punchout_dialog">
                        Reason for Early Punch Out{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        placeholder="Enter Reason for Early Punch Out"
                        fullWidth
                        multiline
                        rows={3}
                        autoComplete="off"
                        value={earlyPunchOutMsg}
                        onChange={(e) => {
                          setEarlyPunchOutMsg(e.target.value);
                          if (e.target.value.trim() !== "") {
                            setErrorText({
                              ...errorText,
                              early_leave_reason: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              early_leave_reason:
                                "Please Enter Your Reason for early Punch Out!",
                            });
                          }
                        }}
                        error={errorText.early_leave_reason}
                        helperText={errorText.early_leave_reason}
                      />
                    </div>
                  ) : null}
                  <div>
                    <Typography className="label_text_final_punchout_dialog">
                      End of Day Report <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      placeholder="Enter End of Day Report"
                      fullWidth
                      multiline
                      rows={3}
                      autoComplete="off"
                      value={updateTempMsg}
                      onChange={(e) => {
                        setUpdateTempMsg(e.target.value);
                        if (e.target.value.trim() !== "") {
                          setErrorText({
                            ...errorText,
                            daily_update: "",
                          });
                        } else {
                          setErrorText({
                            ...errorText,
                            daily_update:
                              "Please Enter Your End of Day Report!",
                          });
                        }
                      }}
                      error={errorText.daily_update}
                      helperText={errorText.daily_update}
                    />
                  </div>
                  <div>
                    <Typography className="label_text_final_punchout_dialog">
                      Code Committed <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      defaultValue={commit}
                      onChange={(e) => {
                        setCommit(e.target.value);
                        setCommitId("");
                        setReason("");
                      }}
                    >
                      <FormControlLabel
                        key="Yes"
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        key="No"
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </div>
                <div>
                  {commit === "Yes" ? (
                    <>
                      <Typography className="label_text_final_punchout_dialog ">
                        Commit ID <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Enter Your Commit ID"
                        value={commitId}
                        fullWidth
                        autoComplete="off"
                        onChange={(e) => {
                          setCommitId(e.target.value);
                          if (e.target.value.trim() !== "") {
                            setErrorText({
                              ...errorText,
                              commit: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              commit: "Please Enter Your Commit ID!",
                            });
                          }
                        }}
                        error={errorText.commit}
                        helperText={errorText.commit}
                      />
                    </>
                  ) : (
                    <>
                      <Typography className="label_text_final_punchout_dialog ">
                        Code Commit Excuse{" "}
                        <span style={{ color: "red" }}>*</span>{" "}
                      </Typography>
                      <TextField
                        placeholder="Enter Your Code Commit Excuse"
                        value={reason}
                        fullWidth
                        autoComplete="off"
                        onChange={(e) => {
                          setReason(e.target.value);
                          if (e.target.value.trim() !== "") {
                            setErrorText({
                              ...errorText,
                              reason: "",
                            });
                          } else {
                            setErrorText({
                              ...errorText,
                              reason: "Please Enter Your  Code Commit Excuse!",
                            });
                          }
                        }}
                        error={errorText.reason}
                        helperText={errorText.reason}
                      />
                    </>
                  )}
                </div>
              </DialogContent>
              <DialogActions
                style={{ justifyContent: "space-evenly", marginBottom: "10px" }}
              >
                <Button
                  block
                  size="large"
                  key="submit"
                  type="primary"
                  onClick={() => {
                    setDisabledTempPunchOut(false);
                    setUpdateTempMsg("");
                    setCommitId("");
                    setReason("");
                    setEarlyPunchOutMsg("");
                    setCurrentWorkingHrs(0);
                    setOpenModalFinalPunchOut(false);
                  }}
                  style={{
                    backgroundColor: "#E20E0E",
                    borderRadius: "6px",
                    color: "white",
                    fontWeight: "500",
                    borderColor: "#E20E0E",
                    textTransform: "none",
                    height: "44px",

                    width: "130px",
                  }}
                >
                  Cancel
                </Button>

                <LoadingButton
                  size="large"
                  onClick={handlePunchOutConfirm}
                  loading={disabledPunchOut}
                  block
                  key="back"
                  id="btndelete"
                  variant="contained"
                  style={{
                    backgroundColor: "#244DA0",
                    borderRadius: "6px",
                    fontWeight: "500",
                    borderColor: "#244DA0",
                    color: "white",
                    textTransform: "none",
                    height: "44px",

                    width: "130px",
                  }}
                >
                  <span>{disabledPunchOut ? "" : "Confirm"} </span>
                </LoadingButton>
              </DialogActions>
            </div>
          </Dialog>
        </Card>
      </div>
    </LeaveStyle>
  );
};

export default Attendance;
